import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import OpenScheduleButton from "../care/OpenScheduleButton";
import * as Tools from "../../helpers/Tools";
import { Link } from "react-router-dom";
import { logUI } from '../../api/andyliticsApi';
import { queryParams } from "../../helpers/formatting";
import {nth, isEqual} from 'lodash';
import moment from 'moment';
import * as queryString from 'query-string';

function Covid19VaccineProviderSlots(props) {

    const { showProviderDetails, prov, isVaccineSearch, locationId, providerSearchModel, defaultPhone, initiateRetry, selectedSlotTime, xid } = props;
   // let earliestScheduleDate = null;
    let openSchedule = [];
    let provAddress = {};
    if (locationId) {
        openSchedule = prov.openSchedule && prov.openSchedule.dateAndTimes;
    }
    else {
        const currentProvloc = prov.locations && prov.locations.length > 0 && prov.locations[0];
        openSchedule = currentProvloc.openSchedules && currentProvloc.openSchedules.dateAndTimes;
        provAddress = {
            street1: currentProvloc.locationStreet1,
            street2: currentProvloc.locationStreet2,
            city: currentProvloc.locationCity,
            state: currentProvloc.locationState,
            zip: currentProvloc.locationZip,
            phone: currentProvloc.locationPhone
        }
    }

    let scheduleDayOneSlots = [];
    let scheduleDayTwoSlots = [];
    let scheduleDayString1 = "";
    let scheduleDayString2 = "";
    let providerMessage1 = "", providerMessage2 = "";
    if (!locationId) {
        if (openSchedule && openSchedule.length > 0) {
            let dt1 = nth(openSchedule, 0);
            let dt2 = nth(openSchedule, 1);
           
            if (!showProviderDetails) {               
                const defaultSelectedDate = selectedSlotTime ? selectedSlotTime : '';
                const nextAvailableDates = openSchedule.filter(item => moment(moment(item.date).format('YYYY-MM-DD')).isSameOrAfter(moment(defaultSelectedDate).format('YYYY-MM-DD')));
                dt1 = nth(nextAvailableDates, 0);
                dt2 = nth(nextAvailableDates, 1);
                if (!dt1 && !dt2) {
                    dt1 = nth(openSchedule, 0);
                    dt2 = nth(openSchedule, 1);
                }

                //if (dt1 && !dt2 && !isEqual(dt1, dt2)) {
                //    dt2 = nth(openSchedule, 0);
                //}
            }
            if (dt1) {
                scheduleDayString1 = dt1.dayString === "Today" ? "TODAY:" : dt1.dayString === "Tomorrow" ? "TOMORROW:" : `${dt1.dayString.slice(0, 3).toUpperCase()} ${dt1.dateString}:`;
                for (var l = 0; l < dt1.times.length; l++) {
                    scheduleDayOneSlots.push(<li key={`${dt1.dayString}scheduleDayOneSlots` + l} ><OpenScheduleButton npi={prov.npi} epicId={prov.epicID} provAddress={provAddress} scheduleData={{...dt1.times[l], providerMessage: dt1.providerMessage}} dayString={dt1.dayString} key={`${dt1.dayString}scheduleDayOneSlots` + l} isVaccineSearch={isVaccineSearch} initiateRetry={initiateRetry} /></li>);
                }
                providerMessage1 = dt1.providerMessage || "Vaccine Unspecified";
            }
            
            if (dt2) {
                scheduleDayString2 = dt2.dayString === "Today" ? "TODAY:" : dt2.dayString === "Tomorrow" ? "TOMORROW:" : `${dt2.dayString.slice(0, 3).toUpperCase()} ${dt2.dateString}:`;
            for (var l = 0; l < dt2.times.length; l++) {
                    scheduleDayTwoSlots.push(<li key={`${dt2.dayString}scheduleDayTwoSlots` + l}><OpenScheduleButton npi={prov.npi} epicId={prov.epicID} provAddress={provAddress} scheduleData={{...dt2.times[l], providerMessage: dt2.providerMessage}} dayString={dt2.dayString} key={`${dt2.dayString}scheduleDayTwoSlots` + l} isVaccineSearch={isVaccineSearch} initiateRetry={initiateRetry} /></li>);
                }

                providerMessage2 = dt2.providerMessage || "Vaccine Unspecified";
            } 

           // earliestScheduleDate = dt1 && dt1.date || dt2 && dt2.date;   
            //if (!earliestScheduleDate) {
            //    const currentDate = new Date();
            //    earliestScheduleDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
            //}
        }
    }

    let vaccineLocUrl = '/findcare/vaccine';
    const {
        location: {
            search = ""
        } = {}
    } = props || {};
    let searchModel = search ? queryString.parse(search) : {};
    let findcareSearchParms = "?" + queryParams({
        location: searchModel && searchModel.loc ? searchModel.loc :
                        providerSearchModel && providerSearchModel.Location ? providerSearchModel.Location : null,
        visitType: searchModel && searchModel.visitTypeId ? searchModel.visitTypeId :
                        providerSearchModel && providerSearchModel.visitTypeId ? providerSearchModel.visitTypeId : null,
        xid: xid ? xid : null
    });
    vaccineLocUrl = vaccineLocUrl + findcareSearchParms;

    const covid19ApptInfo = () => {
        const { history, prov: { epicID: providerId = "" }, providerSearchModel: { location = "", visitTypeId = "" }, xid } = props;
        let apptScheduleUrl = `/covidvaccine/schedule?provId=${providerId}&visitTypeId=${visitTypeId}`;
        let routeState = { isCovidVaccineScheduleEligible: true, xid: xid }; 
        if (location) {
            apptScheduleUrl += `&loc=${location}`
        }
        //if (earliestScheduleDate) {
        //    apptScheduleUrl += `&stime=${earliestScheduleDate}`;
        //}
        history.push(apptScheduleUrl, routeState);
    }

    return (
        <div className={"col item-time-blocks-container"}>
            {((prov.isReferable || isVaccineSearch)) ?
                <div className="row item-times-container">
                    <div className="col-12 col-sm-6 appt-time-list">
                        <div className="day-string">{scheduleDayString1} <span className="vaccine-type">{providerMessage1}</span></div>
                        <ul>{scheduleDayOneSlots}</ul>
                    </div>

                    <div className="col-12 col-sm-6 appt-time-list">
                        <div className="day-string"> {scheduleDayString2} <span className="vaccine-type">{providerMessage2}</span></div>
                        <ul>{scheduleDayTwoSlots}</ul>
                    </div>
                    {openSchedule && openSchedule.length > 2 && <div className="col-12 appt-time-more">
                        {!showProviderDetails && <span className="appt-time-more__text">Don't see a time that works?{' '}</span>}
                        {!showProviderDetails ?
                            <Link className="btn btn-primary" to={vaccineLocUrl}
                                onClick={() => { logUI("MBHWeb.UI.Covid19VaccineScheduleError.NewSearchClicked", new Date(), Tools.getURLPath()) }}>
                                New Search</Link>
                            : <button type="button" className="btn text-btn"
                                onClick={() => { covid19ApptInfo(); logUI("MBHWeb.UI.FindCareResults.ScheduleMoreLinkClicked", new Date(), Tools.getURLPath()) }}>
                                See More</button>
                        }
                    </div>
                    }
                </div> :
                <div className="item-appt-no-open-schedule--list">
                    {prov.isReferable ?
                        <div className="call-appt-container">
                            {defaultPhone &&
                                <a href={"tel:" + defaultPhone} className="phone-link">
                                    <div className="call-appt-icon"><span className="icon-call" /></div>
                                    <div className="call-appt-text"><span className="call-appt-asterisk"><sup>*</sup></span>Call to schedule</div>
                                </a>
                            }
                        </div> :
                        <div className="no-appt-container">
                            <div className="no-appt-text">Not available for appointments</div>
                        </div>
                    }
                </div>
            }
        </div>
    )
}
const mapStateToProps = (state, ownProps) => {
    return {
        providerSearchModel: state.providers.searchModel,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Covid19VaccineProviderSlots));